import { useState, useEffect, useContext, useRef } from 'react';

import { PracticeReseveContext } from '../../../../PracticeReseveContext';
import PracticeReserveSituationCaseCategory from './category/PracticeReserveSituationCaseCategory';

import {
  PracticeReserveSituationDisplaySituations, PracticeReserveSituationDisplaySituation,
} from '../../../../../../../models/practice/reserve/situation/PracticeReserveSituation';
import { PracticeReserveSituationType } from '../../../../../../../models/practice/reserve/situation/type/PracticeReserveSituationType';


function PracticeReserveSituationCase(props: any) {

  const type: PracticeReserveSituationType = props.type;

  const displaySituations: PracticeReserveSituationDisplaySituations = useContext(PracticeReseveContext).displaySituations;

  // カテゴリ一覧表示(他は閉じる)
  const openCateKey = props.openCateKey;
  const setOpenCateKey = props.setOpenCateKey;
  const cateRefs = props.cateRefs;


  return (
    <>
      <div
        className="list-group-item"
        style={{
          height: '50px',
          lineHeight: '30px',
          padding: '10px',
          backgroundColor: '#8CCBDD',
        }}
      >
        <img
          src={type?.icon}
          className="pull-left"
          style={{ height: '25px', marginRight: '10px' }}
          alt={type?.iconAlt}
        />
        <span style={{ color: '#fff', fontWeight: 'bold' }}>{type?.title}</span>
      </div>

      {/* カテゴリごと */}
      {displaySituations &&
        displaySituations.map((item: PracticeReserveSituationDisplaySituation) => (
          <PracticeReserveSituationCaseCategory
            key={item.key}
            type={type}
            category={item.key}
            lineList={item.value}
            label={item.label}
            openCateKey={openCateKey}
            setOpenCateKey={setOpenCateKey}
            cateRef={(el: HTMLDivElement | null) => {
              cateRefs.current[item.key] = el;
            }}
          />
        ))
      }
    </>
  );
}
  
export default PracticeReserveSituationCase;